import type { Course, User } from '@/payload-types'

export const SCANNER_COURSE_SLUG = 'leefstijl-welzijn-complete-cursus'

type ScannerAccessUser = Pick<User, 'roles' | 'purchasedCourses'>

export const userHasScannerAccess = (
  user?: ScannerAccessUser | null,
  scannerCourseID?: number | string,
): boolean => {
  if (!user) return false
  if (user.roles?.includes('admin')) return true

  return ((user.purchasedCourses || []) as Array<Course | number>).some((course) => {
    if (typeof course === 'object') {
      return (
        course.slug === SCANNER_COURSE_SLUG ||
        (scannerCourseID !== undefined && Number(course.id) === Number(scannerCourseID))
      )
    }
    return scannerCourseID !== undefined && Number(course) === Number(scannerCourseID)
  })
}
